module.exports = __webpack_public_path__ + "static/media/JustActMailers_10-09.d13c7957.jpg";